module.exports = __webpack_public_path__ + "static/media/con_spa_det_mon.d9b09309.png";